export const downloadStr = (content:string, fileName:string) => {
    const contentType = 'text/plain';
    var a = document.createElement("a");
    var file = new Blob([content], {type: contentType});
    a.href = URL.createObjectURL(file);
    a.download = fileName;
    a.click();
}